var map = {
	"./arrow_back.svg": "bf21",
	"./home.svg": "83e0",
	"./library_music.svg": "9ffa",
	"./more_vert.svg": "1a87",
	"./pause.svg": "16b2",
	"./play_arrow.svg": "57b2",
	"./search.svg": "e96c",
	"./settings.svg": "8462",
	"./skip_next.svg": "64ae",
	"./skip_previous.svg": "dd10"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "957c";